import * as React from 'react';
import { FixMeLater } from '../../utils';
import { FieldBase, FieldBaseProps } from '../FieldBase/FieldBase';
import { StylerProps } from '../Styler';
import { STATIC_STYLES } from './IFrameField.styles';

export interface IFrameFieldProps
    extends Pick<FieldBaseProps, 'disabled' | 'fullWidth' | 'size' | 'icon' | 'focused' | 'label' | 'validationStatus'>,
        React.IframeHTMLAttributes<HTMLIFrameElement> {
    /**
     * A reference passed to the `iframe` element.
     */
    iFrameRef?: React.Ref<HTMLIFrameElement>;

    /**
     * The title attribute of the `iframe` element.
     */
    title: string;

    /**
     * Additional properties applied to the field's root element.
     */
    FieldRootProps?: StylerProps;

    /**
     * Allow any data-* attribute.
     */
    [key: `data-${string}`]: string;

    /**
     * A reference passed to the root element.
     */
    ref?: React.Ref<FixMeLater>;
}

export function IFrameField(props: Readonly<IFrameFieldProps>): React.JSX.Element {
    const {
        disabled,
        fullWidth,
        iFrameRef,
        label,
        size = 'm',
        title,
        focused,
        validationStatus,
        FieldRootProps,
        ref,
        ...other
    } = props;

    return (
        <FieldBase
            ref={ref}
            disabled={disabled}
            fullWidth={fullWidth}
            contains="Iframe"
            size={size}
            focused={focused}
            validationStatus={validationStatus}
            {...FieldRootProps}
        >
            <iframe ref={iFrameRef} css={STATIC_STYLES} title={title} data-cs-mask="" {...other} />
        </FieldBase>
    );
}
